import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBars from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import InfoIcon from "@material-ui/icons/Info";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  small: {
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
}));

function AppBar() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <AppBars position="fixed">
        <Toolbar>
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="menu"
          >
            <Avatar
              alt="logo"
              src="./images/logo192.png"
              className={classes.small}
            />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            Tip and Bill Calculator
          </Typography>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            href="/About"
          >
            <InfoIcon />
          </IconButton>
        </Toolbar>
      </AppBars>
    </div>
  );
}

export default AppBar;
